module.exports = __webpack_public_path__ + "assets//be239277e5eaff6e2e430545c010d018.png";